import { withStyles } from "@material-ui/core";
import React, {Suspense, lazy} from "react";
import DataGrid from '@dataGrid';
import GridConfig from "./gridConfig";
import GridHeader from "../../../components/GridHeader";
import StatusBar from '@dataGrid/components/StatusBar';
import { getSpecialNeedsOptionsWithServiceLevel } from "../../../../utils";
import { isEqual } from "lodash";
import { compose } from "recompose";
import { withAppConfig } from "../../../../../../appConfigContext";
import styles from "../../../common/GridStyles";
import { AppLoading } from "../../../../../../loaders/loaders";
const ProImages = lazy(() => import("@ProImages"));

class DueBillsGrid extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchText: "",
      showProImagesPopup: false,
      selectedProId: "",
    };
    this.gridConfig = new GridConfig({
      userConfig: this.props.userProfile?.columnPref,
      columnConfig: this.props.configJSON?.gridColumnConfig,
    });
    this.gridContext = {
      hasProImagesURL: this.hasProImagesURL(),
      specialNeedsOptions: getSpecialNeedsOptionsWithServiceLevel(this.props.serviceLevelList),
    };
  }

  componentDidMount() {
    this.props.glEventHub.on("dueBillsGrid", this.onSearchTextChanged);
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps.serviceLevelList, this.props.serviceLevelList)) {
      this.gridContext = {
        specialNeedsOptions: getSpecialNeedsOptionsWithServiceLevel(this.props.serviceLevelList),
      };
    }
  }

  componentWillUnmount() {
    this.props.glEventHub.off("dueBillsGrid", this.onSearchTextChanged);
  }

  onGridReady = ({ api }) => {
    this.gridApi = api;
    this.props.onGridReady({ api });
    this.selectPros();
    this.forceUpdate();
  };

  hasProImagesURL = () => {
    return Boolean(this.props.configJSON.proImagesUrl);
  }

  onCellMouseDown = (params) => {
    this.setState({selectedProId: params.data.proId});
    if (this.hasProImagesURL() && params.column.colId === "proId") {
      this.updateModalVisibility(true);
    }
  };

  updateModalVisibility = (showProImagesPopup) => {
    this.setState({
      showProImagesPopup,
    });
  };

  selectPros = () => {
    this.gridApi.forEachNode((node) => {
      if (
        this.props.selectedPros.includes(node.data.proId) ||
        node.data.isInPlan
      ) {
        node.setSelected(true);
      }
    });
  };

  isRowSelectable = (params) => {
    return !params.data.isInPlan;
  };

  onSearchTextChanged = (searchText) => {
    this.setState({
      searchText,
    });
  };

  constructStatusBar = (filteredData) => {
    return [
      {
        label: filteredData.length + " Due Bills",
        filterCondition: "",
      },
    ];
  };

  render() {
    const { config } = this.gridConfig;
    const { classes, rowData } = this.props;
    return (
      <div className={`${classes.dataGrid} ${classes.gridContent}`}>
        <GridHeader
          title="Due Bills"
          headerId="dueBillsGrid"
          glEventHub={this.props.glEventHub}
          gridApi={this.gridApi}
          userProfile={this.props.userProfile}
          trailerDetails={this.props.trailerDetails}
          showTrailerDetails={true}
        />
        <DataGrid
          rowData={rowData}
          defaultColDef={config.defaultColDef}
          columnDefs={config.columns}
          config={config}
          rowSelection={config.rowSelection}
          rowDeselection={config.rowDeselection}
          deltaRowDataMode={true}
          suppressRowClickSelection
          quickFilterText={this.state.searchText}
          onCellMouseDown={this.onCellMouseDown}
          panelLabel={(filteredData) => (
            <StatusBar data={this.constructStatusBar(filteredData)} />
          )}
          context={this.gridContext}
          rowClassRules={config.rowClassRules}
          onGridReady={this.onGridReady}
          getRowId={(params) => params.data.proId}
          isRowSelectable={this.isRowSelectable}
        />
        <Suspense fallback={<AppLoading />}>
          {this.state.showProImagesPopup && (
            <ProImages
              proNumber={this.state.selectedProId}
              show={this.state.showProImagesPopup}
              onClose={() => {
                this.updateModalVisibility(false);
              }}
            />
          )}
        </Suspense>
      </div>
    );
  }
}

export default compose(withAppConfig, withStyles(styles))(DueBillsGrid);
